<template>
<v-container >
  

         <v-dialog
            v-model="$store.state.dialogoProductoPadre"
              max-width="500px"
            >
          <v-system-bar window dark>
        <v-icon @click="$store.commit('dialogoProductoPadre')">mdi-close</v-icon>
      </v-system-bar>
      <v-card
        class="mx-auto pa-1"
        color="white"
        max-width="500px"
      >
          <v-form
              ref="form"
              class="pa-3"
              v-model="valid"
              lazy-validation
            >
              <v-text-field
              class="mt-n1"
                v-model="codigoProducto"
                :counter="8"
                label="Codigo (Opcional)"
              ></v-text-field>

              <v-row class="mt-n5">
              <v-col cols="6" xs="6">
              <v-text-field
                v-model="Nombre"
                :counter="8"
                :rules="Nombrerules"
                label="Nombre Producto"
                required
              ></v-text-field>
              </v-col>
              <v-col cols="6" xs="6">
                <v-text-field
                v-model="marca"
                :counter="8"
                :rules="Nombrerules"
                label="Marca"
                required
              ></v-text-field>
              </v-col>
              </v-row>
                <v-text-field
                class="mt-n5"
                v-model="descripcion"
                :counter="8"
                :rules="Nombrerules"
                label="Descripcion"
                required
              ></v-text-field>

              <v-row class="mt-n5">
              <v-col cols="6" xs="6">
              <v-text-field
                v-model="pnormal"
                :counter="8"
                :rules="Nombrerules"
                label="Precio Normal"
                required
              ></v-text-field>
              </v-col>
              <v-col cols="6" xs="6">
                <v-text-field
                v-model="pdescuento"
                :counter="8"
                :rules="Nombrerules"
                label="Precio Descuento"
                required
              ></v-text-field>
              </v-col>
              </v-row>

              <v-row class="mt-n5">
              <v-col cols="6" xs="6">
                <v-text-field
                v-model="orden"
                :counter="8"
                :rules="Nombrerules"
                label="orden"
                required
              ></v-text-field>
              </v-col>
              <v-col cols="6" xs="6">
            <v-btn color="error"
              @click="fotosube=true"
              >sube foto</v-btn>
              </v-col>
              </v-row>

              <v-row class="mt-n8">
                <v-col cols="4" xs="4">
                <v-btn
                class="mt-4"
                  :disabled="!valid"
                    :color="$store.state.colorselecto"
                    @click="$store.commit('dialogoaPaletaColores')"
                  >
                    Color
                  </v-btn>
                </v-col>
                <v-col cols="4" xs="4">
              <v-switch v-model="oferta" label="OFF"></v-switch>
                </v-col>
                <v-col cols="4" xs="4">
              <v-switch v-model="nuevo" label="NEW"></v-switch>
                </v-col>
                </v-row>

            </v-form>
 
        <v-card-actions>
              <v-row class="mt-n10">
              <v-col cols="6" xs="6">
                  <v-btn
                  block
                :disabled="!valid"
                  color="success"
                  class="mr-4"
                  @click.stop="agregar"
                >
                  Guardar
                </v-btn>
              </v-col>
               <v-col cols="6" xs="6">
              <v-btn
                block
              :disabled="!valid"
                color="error"
                class="mr-4"
                @click.stop="eliminar"
              >
                Eliminar
              </v-btn>
              </v-col>
              </v-row>
      

         <v-dialog
            v-model="progress"
            max-width="200"
            >
            <v-card>
                 <v-progress-circular
                  :rotate="90"
                  :size="200"
                  :width="15"
                  :value="Uploadvalue"
                  color="red"
                >
                  {{ Uploadvalue }}
                </v-progress-circular>
            </v-card>

         </v-dialog>
        <v-dialog
            v-model="fotosube"
            width="300"
            height="400"
            class="text-center mx-auto"
            transition="dialog-transition"
          >
             <croppa
           width="300"
            height="400"
           class="text-center mx-auto black" 
           v-model="myCroppa"
           placeholder="Agrega Imagen"
          >  
          </croppa >
          <v-btn
          block
           color="error"
              @click="fotosube=false"
              >graba</v-btn>
          </v-dialog>

        </v-card-actions>

      </v-card>
           <paletaColores/>
     </v-dialog>
</v-container>
</template>

<script>
import { db } from '../db'
import store from '@/store/index'
import paletaColores from '@/components/paletaColores'
var ref = db.database().ref("productosPadre")

  export default {
    name: 'agregaCategoria',
        components: {
        paletaColores
        },

    props:[
      'Nombre',
      'picture',
      'color',
      'orden',
      'linea',
      'categoria',
      'marca',
      'pnormal',
      'pdescuento',
      'oferta',
      'nuevo',
      'descripcion',
      'uuid',
      'codigoProducto'

      
    ],


    data() {
        return {

        fotosube:false,
        myCroppa:'',
        orden:'',
        progress: false,
        selectedFile:null,
        Uploadvalue:0,
        picture:null,
        valid: true,
        Nombre: '',
        color:'',
        Nombrerules: [
        v => !!v || 'Obligatorio',
        v => (v && v.length > 0) || 'No puede ser vacio',
      ],

        }
      },
  

      beforeDestroy () {
         clearInterval(this.interval)
      },
       methods: {

        agregar(){
        this.Nombre= this.Nombre.replace("/",' - ')
                this.validate()
            if(this.Nombre!="" ){
                this.onupload()
                
            }
        },

        eliminar(){
            if(this.Nombre!="" ){
             // Create a reference to the file to delete
              var desertRef = db.storage().ref(`/imagenesProductosPadre/${this.uuid}`)

              desertRef.delete().then(function() {

                console.log("exito")
              }).catch(function(error) {
                // Uh-oh, an error occurred!
                  console.log("fallo", error)
              });

              ref.child(this.uuid).remove()
               store.commit('dialogoProductoPadre')
            }
        },

        onupload(){
          var codlinea
          if(this.uuid!=''){
              codlinea = this.uuid
          }else{
            codlinea = this.create_UUID()
            this.contadores(this.codigoProducto)
          }
              ref.child(codlinea).child("nombre").set(this.Nombre.trim())
               ref.child(codlinea).child("color").set(store.state.colorselecto)
               ref.child(codlinea).child("orden").set(this.orden)
               ref.child(codlinea).child("marca").set(this.marca)
               ref.child(codlinea).child("pnormal").set(this.pnormal)
               ref.child(codlinea).child("pdescuento").set(this.pdescuento)
               ref.child(codlinea).child("oferta").set(this.oferta)
               ref.child(codlinea).child("nuevo").set(this.nuevo)
               ref.child(codlinea).child("linea").set(this.linea)
               ref.child(codlinea).child("categoria").set(this.categoria)
               ref.child(codlinea).child("descripcion").set(this.descripcion)
               ref.child(codlinea).child("identificador").set(codlinea)
               ref.child(codlinea).child("codigoProducto").set(this.codigoProducto)
                
          if(this.myCroppa){
              this.myCroppa.generateBlob(
                blob => {
                    this.progress = true
                  const storageRef = db.storage().ref(`/imagenesProductosPadre/${codlinea}`)
                  const task=storageRef.put(blob)
                  task.on('state_changed',snapshot=>{
                    let porcentaje = (snapshot.bytesTransferred/snapshot.totalBytes)*100
                    this.Uploadvalue = porcentaje
                  },error=>{console.log(error.message)},
                  ()=>{this.Uploadvalue=100;
                        task.snapshot.ref.getDownloadURL().then((url)=>{
                          this.picture = url;
                              console.log("existe")
                        ref.child(codlinea).child("foto").set(this.picture)
                          this.progress = false
                          console.log(this.picture)
                        })
                  })
         
         },
        'image/webp',
        0.8
      )}
                this.Nombre='',
                this.selectedFile='',
                this.intervalo=''
                this.uuid=''
                
                this.codigoProducto=''
                store.commit('dialogoProductoPadre')
        },

         contadores(numeracionPedido){
            var a = parseInt(numeracionPedido, 10) +1;
            db.database().ref("contadores").child('codigoProducto').set(a);
        },
     
          create_UUID(){
              var dt = new Date().getTime();
              var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
                  var r = (dt + Math.random()*16)%16 | 0;
                  dt = Math.floor(dt/16);
                  return (c=='x' ? r :(r&0x3|0x8)).toString(16);
              });
              return uuid;
          },

        validate () {
            this.$refs.form.validate()
        },


      },



  }
</script>